import * as React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';

// Support the legacy configured label without adding another module-selection step.
export const isWipTrackingCard = name => /^wip\s+tra?cking$/i.test(String(name || '').trim())
  || /^wip\s+tacking$/i.test(String(name || '').trim());

function CardPhotoToUseLocation(props) {
  const location = useLocation();
  const { bu, plant, factory } = useParams();
  const isWip = Boolean(bu && plant && factory && isWipTrackingCard(props.name));
  const displayName = isWip ? 'WIP Tracking' : props.name;
  function storeCourse(name) {
    localStorage.setItem('factoryName', name)
  }

  return (
    <Card
      sx={{
        width: 200,
        height: 200,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
        boxShadow: '0px 3px 15px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
      }}
    >
      <CardActionArea
        component={Link}
        to={isWip ? '/' + [bu, plant, factory, 'WIP Tracking'].map(encodeURIComponent).join('/') + location.search : `${location.pathname}${props.name}/`}
        onClick={() => storeCourse(props.name)}
        sx={{
          height: '80%',
        }}
      >
        <CardMedia
          component="img"
          image={props.fileLocation}
          alt={displayName}
          sx={{
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </CardActionArea>
      <CardContent
        sx={{
          height: '20%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 1,
        }}
      >
        <Typography style={{ color: '#000000', fontSize: 18, paddingTop: 5 }} >
          {displayName}
        </Typography>
        {/* <Button size="small">
            Enter
          </Button> */}
      </CardContent>
    </Card>
  )
}

export default CardPhotoToUseLocation
